<template>
  <ModalBackground v-if="modalClass" @click="unsetModal" />
  <EditConfigModal ref="modal" v-show="modalClass === 'EditConfigModal'" :config="modalData ?? {}" />
</template>

<script>
import ModalBackground from './ModalBackground.vue'
import EditConfigModal from './EditConfigModal.vue'
import { emitter } from '@/util/emitter.js'
import { getPageUrl } from '@/util/page-url.js'

/**
 * Set the query params for the modal
 * The modal name is base64 encoded
 * 
 * @param modalName {string} - the name of the modal to set
 */
export const setQueryParams = (modalName) => {
  const url = getPageUrl();
  if (
    modalName
    && !['null', 'undefined'].includes(modalName)
  ) {
    url.searchParams.set('modal', btoa(modalName));
    window.history.replaceState({}, '', url);
  } else {
    url.searchParams.delete('modal');
    window.history.replaceState({}, '', url);
  }
}

/**
 * Get the modal query param value
 * 
 * @returns {string} - the modal name
 */
export const getQueryParam = () => {
  const url = getPageUrl();
  let rawValue = url.searchParams.get('modal') ?? '';
  if (['null', 'undefined'].includes(rawValue)) {
    setQueryParams();
    rawValue = url.searchParams.get('modal');
  }

  const result = atob(rawValue);
  return result;
}

export default {
  name: 'ModalComponent',
  components: {
    ModalBackground,
    EditConfigModal,
  },
  props: {
    modal: String,
    data: Object,
  },
  data() {
    return {
      modalClass: this.getQueryParam() ?? null,
      modalData: null,
    }
  },
  methods: {
    setModal(modal, data) {
      this.modalClass = modal;
      this.modalData = data;

      this.setQueryParams(modal);
    },
    unsetModal() {
      this.modalClass = null;
      this.modalData = null;

      this.setQueryParams();
    },
    showModal(eventData) {
      if (eventData?.modal) {
        // set if different
        this.setModal(eventData?.modal, eventData.data);
      } else if (!eventData.modal) {
        // otherwise unset
        this.unsetModal();
      }
    },
    getQueryParam,
    setQueryParams,
  },
  watch: {
    modal(newVal) {
      this.setModal(newVal, this.data);
      if (this.modalClass) this.showModal({ modal: this.modalClass, data: this.modalData });
    },
    data(newVal) {
      this.setModal(this.modal, newVal);
    },
  },
  mounted() {
    emitter.on('show-modal', this.showModal);
    emitter.on('hide-modal', () => this.showModal(undefined));
  },
  beforeUnmount() {
    emitter.all.clear()
  },
}
</script>

<style scoped>
  .modal-component {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
</style>
